import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Activity, Scale } from 'lucide-react';

const ClinicsSection = () => {
  const { t } = useLanguage();

  const clinics = [
    {
      icon: Activity,
      title: t('clinic1_title'),
      desc: t('clinic1_desc'),
      color: 'from-emerald-500 to-teal-600',
    },
    {
      icon: Scale,
      title: t('clinic2_title'),
      desc: t('clinic2_desc'),
      color: 'from-teal-500 to-blue-600',
    },
  ];

  return (
    <section
      id="clinics"
      className="section-padding bg-soft-sky"
      data-testid="clinics-section"
    >
      <div className="section-container">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="text-[#800000] font-semibold text-sm uppercase tracking-wider">
            {t('clinics_subtitle')}
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 p-2"
            data-testid="clinics-title"
          >
            {t('clinics_title')}
          </h2>
        </div>

        {/* Clinics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {clinics.map((clinic, index) => (
            <div
              key={index}
              className="relative bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group"
              data-testid={`clinic-card-${index + 1}`}
            >
              {/* Gradient Background */}
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${clinic.color} opacity-10 rounded-full transform translate-x-10 -translate-y-10 group-hover:scale-150 transition-transform duration-500`}></div>
              
              <div className="relative">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${clinic.color} flex items-center justify-center mb-5`}>
                  <clinic.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{clinic.title}</h3>
                <p className="text-slate-600 leading-relaxed">{clinic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClinicsSection;
